import { styled } from "styled-components";
const CalendarHeaderWrapper = styled("div")({
  alignItems: "center",
  borderBottom: "1px solid rgba(0, 0, 0, 0.09)",
  display: "flex",
  padding: "8px 4px"
});
const CalendarTitle = styled("h1")(({ theme }) => ({
  color: "rgba(0, 0, 0, 0.85)",
  flex: "1 1 0",
  fontSize: "inherit",
  fontWeight: theme.fontWeight.medium,
  margin: 0,
  textAlign: "center"
}));
const CalendarHeaderControl = styled("div")({
  flex: "0 0 auto",
  padding: "0 4px"
});
export {
  CalendarHeaderControl,
  CalendarHeaderWrapper,
  CalendarTitle
};
